import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Typography } from "@material-ui/core";
import ScrollAnimation from "react-animate-on-scroll";
import "animate.css/animate.min.css";
import Uoft from "../Img/uoft.jpg";
import {
  COLOR_FONT,
  COLOR_HIGH,
  COLOR_MID,
  SPACING_BIG,
  SPACING_MED,
  SPACING_XBIG,
  SPACING_XSMALL,
} from "../constants";

const useStyles = makeStyles((theme) => ({
  root: {
    marginLeft: SPACING_MED,
    marginRight: SPACING_MED,
    marginBottom: SPACING_BIG,
    color: COLOR_FONT,
    [theme.breakpoints.up("md")]: {
      marginLeft: "15%",
      marginRight: "15%",
    },
  },
  title: {
    color: COLOR_HIGH,
    marginTop: SPACING_XBIG,
    paddingTop: SPACING_MED,
  },
  subtitle: {
    color: COLOR_MID,
    marginTop: SPACING_MED,
    marginBottom: SPACING_XSMALL,
  },
  desc: { marginBottom: SPACING_XSMALL },
  imgholder: { width: "auto", display: "inline-block", marginTop: SPACING_BIG },
  img: {
    width: "100%",
    height: "auto",
  },
}));

function Education() {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <ScrollAnimation animateIn="fadeIn" offset={50}>
        <Typography
          variant="h3"
          component="h3"
          className={classes.title}
          id={"education"}
        >
          EDUCATION
        </Typography>
        <div className={classes.imgholder}>
          <img src={Uoft} alt={""} className={classes.img} />
        </div>
        <Typography variant="h4" component="h4" className={classes.subtitle}>
          Bachelor of Applied Science and Engineering
        </Typography>
        <Typography
          variant="body1"
          display="block"
          gutterBottom
          className={classes.desc}
        >
          University of Toronto, Toronto, ON
        </Typography>
        <Typography
          variant="body1"
          display="block"
          gutterBottom
          className={classes.desc}
        >
          Department of Computer Engineering
        </Typography>
      </ScrollAnimation>
    </div>
  );
}

export default Education;
